import gql from 'graphql-tag';



export const GetContractorReviewByIds = gql`
  query getContractorReviewByIds($applicationid: String,$contractorid: String){
    contractorReviewByIds(applicationid: $applicationid , contractorid: $contractorid) {
      id
      contractorid
      review
      response
      responseDate
     }
  }
`;

export const GetcontractorReviewByIdQuery = gql`
  query GetcontractorReview($id: String){
    contractorReview(id: $id) {
      id
      review
      response
      responseDate
    }
  }
`;

export const GetContractorReviewsQuery = gql`
  query GetcontractorReviews($contractorid: String){
    contractorReviews(contractorid: $contractorid) {
      id
      review
      modifiedOn
      createdOn
      response
      responseDate
     }
  }
`;
